import { render } from "./ListaPersonajes.vue?vue&type=template&id=97eb0c86&scoped=true"
import script from "./ListaPersonajes.vue?vue&type=script&lang=js"
export * from "./ListaPersonajes.vue?vue&type=script&lang=js"

import "./ListaPersonajes.vue?vue&type=style&index=0&id=97eb0c86&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97eb0c86"]])

export default __exports__